export const selectPendingPromptData = (state) => state.prompt.pendingPromptData;